/*
 *  ZAITEC CONFIDENTIAL
 *  __________________
 *
 * [2019] - [2020] zaiTEC Logixs Ltd
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of  zaiTEC Logixs Ltd and its suppliers,if any.
 *  The intellectual and technical concepts contained herein are proprietary to zaiTEC Logixs Ltd, and are protected by
 *  trade secret or copyright law.Dissemination of this information or reproduction of this material is strictly forbidden
 *  unless prior written permission is obtained from  zaiTEC Logixs Ltd.
 */

import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable()
export class ErrorHandlerSnakBar {

  private lastMessage = '';
  private isSnackbarOpen = false;

  constructor(
    public snackbar: MatSnackBar,
  ) {}

  // public handleError(message: any) {
  //   this.snackbar.open(message, 'Close', { duration: 5000, verticalPosition: 'bottom', panelClass: 'snack-error'});
  // }

  public handleError(message: string): void {
    // Prevent duplicate messages from appearing
    if (!this.isSnackbarOpen || message !== this.lastMessage) {
      this.lastMessage = message;
      this.isSnackbarOpen = true;

      const snackBarRef = this.snackbar.open(message, 'Close', { 
        duration: 5000, 
        verticalPosition: 'bottom', 
        panelClass: 'snack-error'
      });

      // Reset state when snackbar is dismissed
      snackBarRef.afterDismissed().subscribe(() => {
        this.isSnackbarOpen = false;
      });
    }
  }
}